import { EventKey, dispatchEvent } from '@tgg/services';
import { Heading, Icon, palette } from '@tgg/ui';
import { relativeUrlWithBasePath } from '@tgg/util';

import withVerticalSpacing from '../../hocs/withVerticalSpacing';

import {
    StyledAppTile,
    StyledContainer,
    SecondaryTitle,
    StyledImageContainer,
    StyledCheckList,
    LinksContainer,
} from './AppTile.styled';
import { AppTileProperties } from './AppTile.types';

const handleClick = (href: string, linkText: string): void => {
    dispatchEvent(EventKey.LINK_CLICK, {
        link_text: linkText,
        link_destination: href,
        component_name: 'app tile',
    });
};

const AppTileComponent = ({
    title,
    secondaryTitle,
    image,
    list,
    appStoreLink,
    playMarketLink,
}: AppTileProperties) => (
    <StyledAppTile data-testid="app-tile-container">
        <StyledImageContainer>{image}</StyledImageContainer>
        <StyledContainer>
            <Heading variant="h3">{title}</Heading>
            {secondaryTitle && (
                <SecondaryTitle>{secondaryTitle}</SecondaryTitle>
            )}
            {list && (
                <StyledCheckList>
                    {list?.map((item, index) => (
                        <li key={index}>
                            <Icon
                                name="tick"
                                color={palette.primary.main}
                                size={20}
                            />
                            {item}
                        </li>
                    ))}
                </StyledCheckList>
            )}
        </StyledContainer>
        <LinksContainer>
            <a
                href={appStoreLink}
                onClick={() => handleClick(appStoreLink, 'App Store app link')}
                target="_blank"
                rel="noreferrer"
                aria-label="App Store app link"
            >
                <img
                    src={relativeUrlWithBasePath(
                        '/ywnqh/images/app_store_badge.svg',
                    )}
                    alt="App Store badge"
                />
            </a>
            <a
                href={playMarketLink}
                target="_blank"
                rel="noreferrer"
                onClick={() =>
                    handleClick(playMarketLink, 'Play Store app link')
                }
                aria-label="Play Store app link"
            >
                <img
                    src={relativeUrlWithBasePath(
                        '/ywnqh/images/google_play_badge.svg',
                    )}
                    alt="Play Store badge"
                />
            </a>
        </LinksContainer>
    </StyledAppTile>
);

export const AppTile = withVerticalSpacing(AppTileComponent);
